// Dot-access on `import.meta.env.VITE_*` so Vite statically inlines each value
// at build time (computed/bracket keys are not replaced).
const _envConfig: { [key: string]: string | undefined } = {
  env: import.meta.env.VITE_ENVIRONMENT,
  baseUrl: import.meta.env.VITE_BASE_URL,
  releaseVersion: import.meta.env.VITE_VERSION,
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  firebaseSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID,
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID,
  firebaseMeasureId: import.meta.env.VITE_FIREBASE_MEASURE_ID,
  stripeKey: import.meta.env.VITE_STRIPE_KEY,
  domainUrl: import.meta.env.VITE_UI_DOMAIN_LINK,
  amplitudeKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  cleverTapKey: import.meta.env.VITE_CLEVER_TAP_ACCOUNT_ID,
  microsoftClarityProjectId: import.meta.env.VITE_MICRSOFT_CLARITY_PROJECT_ID,
  b2BucketUrl: import.meta.env.VITE_B2_BUCKET_URL,
  partner: import.meta.env.VITE_PARTNER,
  isHolidayDiscountActive: import.meta.env.VITE_IS_HOLIDAY_DISCOUNT_ACTIVE,
  holidayDiscountPercentage: import.meta.env.VITE_HOLIDAY_DISCOUNT_PERCENTAGE,
  holidayDiscountCoupon: import.meta.env.VITE_HOLIDAY_DISCOUNT_COUPON,
  freeTrialDays: import.meta.env.VITE_FREE_TRIAL_DAYS,
  freeTrialDaysTrailCamera: import.meta.env.VITE_FREE_TRIAL_DAYS_TRAIL_CAMERA
};

const envConfig = (key: string) => {
  return _envConfig[key];
};

export default envConfig;
